import { actionCreators } from 'app/area/links-section/actions';
import { selectFetchingLinks, selectLinks } from 'app/area/links-section/selectors';
import { useEffect, useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { bindActionCreators } from 'redux';

export function useSelectors() {
  const fetchingLinks = useSelector(selectFetchingLinks);
  const linksGroups = useSelector(selectLinks);

  return {
    fetchingLinks,
    linksGroups
  };
}

export function useActionCreators() {
  const dispatch = useDispatch();
  
  return useMemo(() => bindActionCreators(actionCreators, dispatch), [dispatch]);
}

export function useLoadLinksEffect() {
  const { loadLinks } = useActionCreators();

  useEffect(() => { loadLinks(); }, []);
}
